/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Integrations_Search_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No integration matches “{query}”." |
*
* @param {Integrations_Search_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_search_no_results = /** @type {((inputs: Integrations_Search_No_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Search_No_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Keine Integration passt zu „${i?.query}“.`)
	return /** @type {LocalizedString} */ (`No integration matches “${i?.query}”.`)
});